module.exports = __webpack_public_path__ + "static/case-studies-hero-afaa82a1c0407c4e75cbb051bae06673.jpg";